export const labelStyle = "font-normal text-sm text-black";
export const inputStyle =
  "w-full resize-none font-normal text-base text-black rounded py-2.5 px-4 bg-themeGray border-none placeholder:text-black placeholder:text-opacity-60 focus:outline-none";
export const errorStyle =
  "w-full bg-themeGray2 border-none font-normal sm:text-base text-sm rounded-lg";
export const style =
  ".react-tel-input {width: 88px} .react-tel-input input {pointer-events: none;}";
